import {EditBloggerFormField} from "../types/edit-blogger-modal.types";

export const editBloggerModalName = 'edit-blogger';

export const editBloggerFormFields: Array<EditBloggerFormField> = [
  {
    label: 'Ник блогера',
    fieldName: 'username',
    type: 'text'
  },
  {
    label: 'Ссылка на Яндекс Диск',
    fieldName: 'yandexDiskLink',
    type: 'text'
  },
  {
    label: 'Категория',
    fieldName: 'category',
    type: 'select'
  },
  {
    label: 'Лояльность',
    fieldName: 'loyaltyType',
    type: 'select'
  }
];
